import _ from 'lodash';
import Section from "../components/Section";
import {Button} from "../components/Button";
import UIState from "../store/uiState";
import {ModalTypes, STAKING_DISABLED} from "../constants";
import {useDispatch, useSelector} from "react-redux";
import {createSelector} from "reselect";
import {formatBalance, truncate} from "../utils";
import Wallet, {
    selectAirdrops,
    selectCurrentAccount,
    selectNFTBalances,
    selectStoreProductsByType
} from "../store/models/wallet";
import {useEffect, useRef, useState} from "react";
import {usePageVisibility} from "../hooks/usePageVisibility";
import {StakeAPYCTA, StakeAPYInfo} from "../components/CTAPill";
import {useTranslation} from "react-i18next";
import logo from "../assets/logos/grove@2x.png";
import metamaskLogo from "../assets/wallets/metamask-white@2x.png";
import thetaWalletLogo from "../assets/wallets/theta-wallet-white@2x.png";
import CharacterViewer from "../components/CharacterViewer";
import {Tab, TabList, Tabs} from "react-tabs";
import tokenIcon from "../assets/logos/grove@2x.png";
import cardCheckmark from "../assets/icons/card/purple-checkmark@2x.png";
import cardNew from "../assets/icons/card/new@2x.png";
import classNames from "classnames";
import PurchaseButton from "../components/PurchaseButton";
import GetMoreGroveButton from "../components/GetMoreGroveButton";
import useMediaQuery from "../hooks/useMediaQuery";
import exclamationIcon from "../assets/icons/card/alert@2x.png";
import Airdrops, {getAirdropBySlug} from "../airdrops";
import Sqids from "sqids";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import cardSoldOut from "../assets/icons/card/sold-out@2x.png";
import cardExclusive from "../assets/icons/card/exclusive@2x.png";

const AirdropCard = ({airdrop}) => {
    const account = useSelector(selectCurrentAccount);
    const dispatch = useDispatch();
    const airdropState = airdrop.state;
    const claimed = airdropState?.hasClaimed;
    const allowed = airdropState?.isAllowed;

    let buttonTitle = 'Claim';
    if (claimed) {
        buttonTitle = 'Claimed';
    } else if (!allowed) {
        buttonTitle = 'Not Eligible';
    }
    if(_.isNil(account)){
        buttonTitle = 'Connect Wallet';
    }

    return (
        <div className={classNames('AirdropCard', {
            ['AirdropCard--claimable']: allowed && !claimed && !_.isNil(account),
            ['AirdropCard--claimed']: claimed,
            ['AirdropCard--not-allowed']: !allowed && !_.isNil(account),
            ['AirdropCard--connect-wallet']: _.isNil(account),
        })}
             onClick={() => {
                 dispatch(UIState.actions.showModal(ModalTypes.Airdrop, {
                     airdrop: airdrop,
                 }));
             }}
        >
            <div className={'AirdropCard__image'}>
                <img src={`${airdrop.image}`}/>
            </div>
            <div className={'AirdropCard__name'}>
                {airdrop.name}
            </div>
            <div className={'AirdropCard__description'}>
                {airdrop.description}
            </div>
            <Button className={'AirdropCard__button'}
                    color={'red'}
                    size={'large'}
                    style={{width: '100%'}}
                    onClick={() => {
                    }}
            >
                {buttonTitle}
            </Button>
        </div>
    );
}

const AirdropsPage = () => {
    let params = useParams();
    const dispatch = useDispatch();
    const account = useSelector(selectCurrentAccount);
    const airdrops = useSelector(selectAirdrops);

    useEffect(() => {
        dispatch(Wallet.actions.tryToRecoverWalletSession());
    }, []);

    useEffect(() => {
        if(account){
            dispatch(Wallet.actions.fetchClaimableAirdropStates());
        }
    }, [account]);

    useEffect(() => {
        if(params.slug) {
            dispatch(UIState.actions.showModalOnce(ModalTypes.Airdrop, {
                airdrop: getAirdropBySlug(params.slug),
            }));
        }
    }, [params.slug]);

    return (
        <div className={'Page AirdropsPage'}>
            <div className={'AirdropsPage__content'}>
                <div className={'AirdropsPage__title'}>Exclusive Airdrops</div>
                <div className={'AirdropsPage__airdrops'}>
                    {
                        airdrops.map((airdrop, index) => {
                            return (
                                <AirdropCard key={index}
                                             airdrop={airdrop}/>
                            )
                        })
                    }
                </div>
            </div>
        </div>
    )
};

export default AirdropsPage;